import React from 'react';

import { AnotherWayLabelsT, AuthViewPropsT } from '../../AuthModal.types';
import { Disclaimer } from '../../components/Disclaimer/Disclaimer';
import {
  SocialProviderButton,
  SocialProvidersView,
} from '../../components/SocialProviders/SocialProviders';
import { StyledAnotherProviders } from '../../components/SocialProviders/SocialProviders.style';
import { StepHeader } from '../../components/StepHeader/StepHeader';

export const AnotherWayView = ({ ...props }: AuthViewPropsT) => {
  const { ...labels } = props.labels as AnotherWayLabelsT;

  return (
    <>
      <StepHeader title={labels.title} onBack={() => props.onChangeView?.('loginEmail')} />

      <SocialProvidersView />
      <StyledAnotherProviders>
        <SocialProviderButton
          id="sp-email"
          name={`${labels.continueWith ?? ''} Email`}
          onClick={() => props.onChangeView?.('loginEmail')}
          icon="email"
        />
      </StyledAnotherProviders>
      <Disclaimer {...labels.disclaimer} />
    </>
  );
};
